module.exports = __webpack_public_path__ + "img/layer7attacks.a0f32d1.svg";